export default __webpack_public_path__ + "static/media/mobiledev-2340x1560.ecbb1d8a.png";